import { render } from "./AudioSyncBlock.vue?vue&type=template&id=49bf453a"
import script from "./AudioSyncBlock.vue?vue&type=script&lang=js"
export * from "./AudioSyncBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/AudioSyncBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49bf453a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49bf453a', __exports__)) {
    api.reload('49bf453a', __exports__)
  }
  
  module.hot.accept("./AudioSyncBlock.vue?vue&type=template&id=49bf453a", () => {
    api.rerender('49bf453a', render)
  })

}


export default __exports__